<template>
 <div :class="windowClass">
    <v-row no-gutters>
            <v-col xs="12" class="pa-2">
                

                    <v-card>
                        <v-card-title>
                        <v-icon large left color="secondary">mdi-cogs</v-icon> MANAGE SETTINGS AND CHARGES 
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        </v-card-title>
                        <v-card-text>
                             <v-data-table
                                class="va-table"
                                :headers="headers"
                                :search="search"
                                :items="settings"
                                hide-default-footer
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                         <td class="text-right">
                                                {{item.name}}
                                         </td>
                                         <td>
                                             <v-text-field
                                                    v-model="item.value"
                                                    single-line
                                                     @change="Update(item)"
                                                    dense
                                                    hide-details
                                                ></v-text-field>
                                         </td>
                                    </tr>
                                    </tbody>
                                </template>
                                </v-data-table>
                        </v-card-text>
                    </v-card>
            </v-col>
    </v-row>
    <!-- <va-settings-form :show="form" :settings="settings" :state="state" @DialogEvent="formEvent" /> -->
  </div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
        form: false,
        state: 'new',
        setting: {},
        search:'',
        settings:[],
        headers: [
            { text: 'Name', align: 'right', sortable: false},
            { text: 'Value', sortable: false}
        ],
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.getSettings()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      formEvent(data){
          this.form = false
          if(data.action != 'close') {
              this.settings = data.settings
              this.Save()
          }
          console.log(data)
      },
       getSettings: function() { 
            this.$http.post("setting/list", JSON.stringify({})).then(response => {
            response.data.data != null?this.settings = response.data.data:this.settings = []
          }).catch(e => {
           console.log(e.data)
         })
     },
     Update(item){
         this.setting = item
         this.state = 'update'
         this.Save()
     },
      Save: function() {
        let method = 'setting/add'
        this.state != 'add'?method='setting/update':method = 'setting/add'
        this.$http.post(method, JSON.stringify(this.setting)).then(response => {
            response.data.status? this.setAlertColor('success'): this.setAlertColor('error')
            this.setAlertText(response.data.message)
            this.setAlert(true)
            this.getSettings()
        }).catch(e => {
        console.log(e)
        })
     },
    }
  }
</script>